import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const addToWishlist = createAsyncThunk(
  "wishlist/add-to-wishlist",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.post(
        `${baseUrl}WishList/api/v1/create`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        },
      );
      console.log("Add to Wishlist response:", response);
      return response.data;
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      return rejectWithValue(
        error.response?.data?.message || "Error adding to wishlist",
      );
    }
  },
);

// REMOVE FROM WISHLIST

export const removeFromWishlist = createAsyncThunk(
  "wishlist/remove-from-wishlist",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.delete(`${baseUrl}WishList/api/v1/delete`, {
        headers: {
          "auth-token": token,
          "Content-Type": "application/json",
        },
        data: data, // For DELETE requests with body, use 'data' property
      });
      console.log("Remove from Wishlist response:", response);
      return response.data;
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      return rejectWithValue(
        error.response?.data?.message || "Error removing from wishlist",
      );
    }
  },
);


export const deleteFromWishlist = createAsyncThunk(
  "client/delete-WishList",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}WishList/api/v1/delete`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        },
      );
      console.log("delete from wishlist response", response.data);
      return response.data; // ✅ This is important
    } catch (error) {
      console.error("Error delete from wishlist:", error);
      return rejectWithValue(
        error.response?.data?.message || "Error deleting from wishlist",
      );
    }
  },
);
